import { useState, useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Alert from "./Alert";
import { alertContext } from "./contexts/AlertProvider";
import { authContext } from "./contexts/AuthProvider";

const Login = () => {
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const { isAuth, setIsAuth } = useContext(authContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const adminAuth = (event) => {
    event.preventDefault();
    axios
      .post(process.env.REACT_APP_API_ENDPOINT + "login", {
        username: username,
        password: password,
      })
      .then((res) => {
        if (res.data.code === 0) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "danger",
          });
        }
        if (res.data.code === 1) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "success",
          });
          localStorage.setItem("token", res.data.data);
          setIsAuth(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (isAuth === true) {
      navigate("/dashboard");
    }
  }, [isAuth]);
  return (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Authentication - Sign-in */}
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        {/*begin::Body*/}
        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
          {/*begin::Form*/}
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            {/*begin::Wrapper*/}
            <div className="w-lg-500px p-10">
              {/*begin::Form*/}
              <form
                className="form w-100"
                noValidate="novalidate"
                id="kt_sign_in_form"
                onSubmit={adminAuth}
              >
                {/*begin::Heading*/}
                <div className="text-center mb-11">
                  {/*begin::Logo*/}
                  <Link to="/" className="mb-0 mb-lg-12">
                    <img
                      alt="Logo"
                      src="../../../assets/media/logos/logo.png"
                      style={{ width: "250px" }}
                    />
                  </Link>
                  {/*end::Logo*/}
                  {/*begin::Title*/}
                  <h1 className="text-gray-900 fw-bolder mb-3">Sign In</h1>
                  {/*end::Title*/}

                  {/*begin::Subtitle*/}
                  <div className="text-gray-500 fw-semibold fs-6">
                    {process.env.REACT_APP_BRAND_NAME || ""} Admin Panel
                  </div>
                  {/*end::Subtitle-*/}
                </div>
                {/*begin::Heading*/}

                {/*begin::Input group-*/}
                <div className="fv-row mb-8">
                  {/*begin::Email*/}
                  <input
                    type="text"
                    placeholder="Email/Username"
                    value={username}
                    onChange={(e) => {
                      setUsername(e.target.value);
                    }}
                    autoComplete="off"
                    className="form-control bg-transparent"
                  />
                  {/*end::Email*/}
                </div>

                {/*end::Input group-*/}
                <div className="fv-row mb-3">
                  {/*begin::Password*/}
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    autoComplete="off"
                    className="form-control bg-transparent"
                  />
                  {/*end::Password*/}
                </div>
                {/*end::Input group-*/}

                {/*begin::Wrapper*/}
                <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                  <div
                    onClick={() => {
                      setShowPassword(!showPassword);
                    }}
                    className="link-primary"
                    style={{ cursor: "pointer" }}
                  >
                    {showPassword ? "Hide Password" : "Show Password"}
                  </div>

                  {/*begin::Link*/}
                  <Link to="/forgot-password" className="link-primary">
                    Forgot Password ?
                  </Link>
                  {/*end::Link*/}
                </div>
                {/*end::Wrapper*/}
                {/*begin::Submit button*/}
                <div className="d-grid mb-10">
                  <button type="submit" className="btn bg-primary link-light">
                    Login
                  </button>
                </div>
                {/*end::Submit button*/}
              </form>
              {/*end::Form*/}
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Form*/}
        </div>
        {/*end::Body*/}
      </div>
      {/*end::Authentication - Sign-in*/}
    </div>
  );
};

export default Login;
